import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.scss';

const MyBiyesadi = () => {
  const links = [
    { to: '/my-ghotokbari/', label: 'Dashboard' },
    { to: '/my-ghotokbari/profile', label: 'Profile' },
    { to: '/my-ghotokbari/photos', label: 'Photo' },
    { to: '/my-ghotokbari/partner-preference', label: 'Partner Preference' },
    { to: '/my-ghotokbari/settings', label: 'Settings' },
    { to: '/my-ghotokbari/contact', label: 'Contact Details' },
    { to: '/my-ghotokbari/package', label: 'Packages' },
    { to: '/my-ghotokbari/paymentlog', label: 'Payment Log' },
  ];

  return (
    <div className="custom-navbar">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-wrap justify-content-start gap-2">
            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                className={({ isActive }) =>
                  isActive ? 'btn shadow-sm isActive' : 'btn shadow-sm'
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBiyesadi;
